module.exports = __webpack_public_path__ + "static/media/depths_teg_logo.7a154115.png";